export default {
  debug: true,
  defaultCustomEventName: "meitav-campaign-landing-pages-events",
};
